import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md"
import { FaHandHoldingHeart } from "react-icons/fa"
import DataTable from 'react-data-table-component';
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import "./master_categories.css";
import { BiSearch } from "react-icons/bi"
import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";
import useDebouncedValue from "../Utils/Debounce";
import { useURLParams } from '../Components/UrlUtils/useURLParams';

const CategoryGroupings = () => {
    const { setParam, getParam } = useURLParams();
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("")
    const [loading, setLoading] = useState(false)
    const [RowId, SetRowId] = useState()
    let navigate = useNavigate();
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("")
    const [message, setMessage] = useState('')
    const [search, SetSearch] = useState({
        search: getParam('search') || ""
    })
    const debouncedSearchTerm = useDebouncedValue(search.search, 500);
    const tableCustomStyles = {
        rows: {
            style: {
            },
        },
        cells: {
            style: {
                justifyContent: "center"
            },
        },
        headCells: {
            style: {
                color: "#5C5C5C",
                justifyContent: "center",
                color: "rgb(33,37,41)",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "28px",
            },
        },
    }
    const [selectedCategoryId, setSelectedCategoryId] = useState({
        subcategory: getParam('subcategory') || "",
        category: getParam('category') || ""
    });
    const [Categories, setCategory] = useState([])
    const categories = async () => {
        await axiosConfig.get("/cms/category_grouping/?page_size=50&is_suspended=false").then(res => {
            setCategory(res.data.results)
        }).catch(error => {
            console.log(error)
        })
    }
    const [Subcategories, setSubcategory] = useState([])
    const subategories = async () => {
        await axiosConfig.get(`/cms/category_grouping/?category=${selectedCategoryId.category}&page_size=500&is_suspended=false`).then(res => {
            setSubcategory(res.data.results)
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        GetData();
        categories()
        subategories();
    }, [currentPage, RowPerPage, selectedCategoryId.category, selectedCategoryId.subcategory, selectedCategoryId.category, debouncedSearchTerm]);



    const [Data, SetData] = useState([])
    const GetData = async () => {
        setLoading(true);
        try {
            let url = `/cms/category_grouping/?page=${currentPage}&page_size=${RowPerPage}&subcategory=${selectedCategoryId.subcategory ? selectedCategoryId.subcategory : ""}&subcategory__category=${selectedCategoryId.category ? selectedCategoryId.category : ""}&search=${debouncedSearchTerm}`;
            const response = await axiosConfig.get(url);
            SetData(response.data.results);
            setLoading(false);
            setTotalRows(response.data.count);
        } catch (error) {
            console.log(error);
        }
    };
    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        console.log(name, value)
        SetSearch({ ...search, [name]: value })
        setParam('search', value);
    }
    const handleSort = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`/cms/category_grouping/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const handleNaigate = () => {
        navigate("/dashboard/masters/categorygrouping/add")
    }
    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true,
            reorder: true,
        },
        {
            name: "Title",
            selector: "title",
            sortable: true,
            reorder: true,
        },
        {
            name: "Category",
            selector: row => (row.category || []).map(cat => (typeof cat === "object" && cat !== null ? cat.name : cat)).join(", "),
            sortable: true,
            reorder: true,
        },
        {
            name: "Promotional Category",
            selector: row => (row.promotional_category || []).map(cat => (typeof cat === "object" && cat !== null ? cat.title || cat.name : cat)).join(", "),
            sortable: true,
            reorder: true,
        },
        {
            name: "Sort",
            selector: row => row.sort,
            sortable: true,
            reorder: true,
        },
        {
            name: "ACTIONS",
            reorder: true,
            selector: row => {
                const HandleEdit = async () => {
                    navigate(`/dashboard/masters/categorygroupingadd/${row.id}/edit`)

                }
                const DeleteAlert = () => {
                    SetRowId(row.id)
                    SetAlertDeletePopupType("success")
                }
                const CancelAlerrt = () => {
                    SetAlertDeletePopupType("error")
                }
                const HandleDelete = async (id) => {
                    await axiosConfig.delete(`/cms/category_grouping/${id}/`).then(() => {
                        SetAlertDeletePopupType("error")
                        setDeletepopupType("success")
                        GetData();
                    }).catch((error) => {
                        setDeletepopupType("error")
                        SetAlertDeletePopupType("error")
                        console.log(error)
                    })
                }
                const handleRevive = async () => {
                    try {
                        const response = await axiosConfig.post(`/cms/category_grouping/${row.id}/revive/`)
                        setpopupType("success")
                        setMessage("Product revived successfully")
                        GetData()
                    } catch (error) {
                        console.log("Error While Reviving", error)
                    }
                }
                return (
                    <>
                        {!row.is_suspended ?
                            <div className="row" >
                                <div className="col-4">
                                    <MdOutlineEdit className="dashboard-tabe-data-actions" onClick={HandleEdit} />
                                </div>
                                <div className="col-4">
                                    <MdDeleteOutline className="dashboard-tabe-data-actions" onClick={DeleteAlert} />
                                </div>
                            </div>
                            :
                            <>
                                <FaHandHoldingHeart className="dashboard-tabe-data-actions" onClick={handleRevive} />
                            </>
                        }
                        {
                            AlertDeletePopupType === "success" &&
                            <AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} HandleDelete={HandleDelete} CancelAlerrt={CancelAlerrt} row={RowId} />
                        }
                    </>
                )

            }
        }
    ]
    return (
        <>
            <div className="child-sidenav">
                <MarketingNavbarComponent />
                <div className="childnav-content">
                    <div>
                        <div className="button-pro">
                            <div className="cat-button">
                                <div className="btn" onClick={handleNaigate} >
                                    + Add New
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="space-flex">
                                {/* <div className="col-6">
                                    <div className="flex">
                                        {console.log(Categories)}
                                        <div className="product-filter">
                                            <Select options={Categories.map(Categories => ({ value: Categories.id, label: Categories.name }))} placeholder="Select Category" value={Categories && Categories.map(res => ({ "value": res.id, "label": res.name })).find(res => res.value === parseFloat(selectedCategoryId.category))||null} onChange={(selectedOption) => {
                                                if (!selectedOption) {
                                                    clearSelection("category"); 
                                                } else {
                                                    handleCategoryFilterChange(selectedOption,"category");
                                                }
                                            }} isClearable required />
                                        </div>

                                    </div>
                                </div> */}
                                <div className="col-6 input-with-icon">
                                    <span className="icon-product"><BiSearch /></span>
                                    <input type="text" className="input-control" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive marginTop">
                            <DataTable
                                columns={columns}
                                data={Data} pagination paginationTotalRows={totalRows}
                                paginationPerPage={RowPerPage}
                                paginationDefaultPage={currentPage}
                                onChangePage={(page) => setCurrentPage(page)}
                                paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                                onSort={handleSort}
                                paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                                progressComponent={<div className="loader-container">
                                    <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                                </div>}
                                subHeaderComponent={
                                    <input type="text" className="form-control w-50" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />} />
                        </div>
                    </div>
                </div>
            </div>
            {popupType != "" &&
                <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="/dashboard/masters/categorygrouping" Message={message} />
            }
            {deletePopupType != "" &&
                <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
            }
        </>
    )
}
export default CategoryGroupings;